import React from 'react';

export const FlagDEIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 300" // Standard 5:3 ratio
    {...props}
  >
    <rect width="500" height="300" fill="#FFCE00" rx="2"/> {/* Gold (Yellow) */}
    <rect width="500" height="200" fill="#DD0000" /> {/* Red */}
    <rect width="500" height="100" fill="#000000" /> {/* Black */}
    {/* Add rx to the top layer for overall rounded effect if preferred, or apply to all */}
     <rect width="500" height="300" fill="none" stroke="#6b7280" strokeOpacity="0.3" strokeWidth="1" rx="2"/>

  </svg>
);